<script>
export default {
  template: `<div style='display: flex; justify-content: center;'>
    <div v-tooltip.left="'Link de tablero'" v-on:click="copyLink({[data.group]: [data.name]})">
      <i class="material-icons is-size-5 has-text-link" style="margin-right: 5px; cursor: pointer">share</i>
    </div>
  </div>`,
  data(){
    return {
      data:{},
      params: {}
    }
  },
  beforeMount() {
    this.params = this.$parent.params;
    this.data = this.params.data;
  },
  methods:{
    copyLink(f){
      this.params.copyLink(f);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/climan/components/buttonsActionGroupClima.vue